import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const apiEmployerAnaliticsSlice = createApi({
  reducerPath: "apiEmployerAnalitics",
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getTimeForAttorneys: builder.query({
      query: (id) => `/api/v2/employer_analytics/attorney_time`,
      transformResponse: (response: any) => response.time_for_attorneys_at_firm
    }),
    getJobStatistics: builder.query({
      query: (id) => `/api/v2/employer_analytics/job_statistics`,
      transformResponse: (response: any) => response.job_statistics
    }),
    getEmployerLocations: builder.query({
      query: (id) => `/api/v2/employer_analytics/locations`,
      transformResponse: (response: any) => response.locations
    }),
    getEmployerJDYearMedian: builder.query({
      query: (id) => `/api/v2/employer_analytics/jd_year_median`,
      transformResponse: (response: any) => response.jd_year_median
    }),
    getEmployerMostAttendedSchools: builder.query({
      query: (id) => `/api/v2/employer_analytics/most_attended_schools`,
      transformResponse: (response: any) => {
        // Handle both old and new response structures
        if (response.schools) {
          return response.schools;
        }
        if (response.most_attended_schools) {
          return response.most_attended_schools;
        }
        return [];
      }
    }),
    getEmployeesPerOffice: builder.query({
      query: (id) => `/api/v2/employer_analytics/employee_per_office`,
      transformResponse: (response: any) => response.offices
    })
  }),

  refetchOnMountOrArgChange: true
});

// Export hooks for usage in functional components
export const {
  useGetTimeForAttorneysQuery,
  useGetJobStatisticsQuery,
  useGetEmployerLocationsQuery,
  useGetEmployerJDYearMedianQuery,
  useGetEmployerMostAttendedSchoolsQuery,
  useGetEmployeesPerOfficeQuery
} = apiEmployerAnaliticsSlice;
